<div class="m-form-field">
  <div class="a-datetime-input">
    @if (label){<label [for]="id">{{ label }} @if(isRequired$ | async){ * } </label>}

    <input
      [id]="id"
      [formControl]="control"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [disabledControl]="isDisabled$ | async"
      type="datetime-local"
      #input
    />
    <button type="button" class="a-datetime-input__button" aria-label="open dialog" (click)="showPicker()">
      <bosch-ui-icon [name]="iconNames.CalendarClock"></bosch-ui-icon>
    </button>
  </div>

  @if (!errorRef && (error$ | async); as error) {
  <bosch-ui-validation-error [error]="'common.validation.error.' + error | translate"></bosch-ui-validation-error>
  } @if (errorRef) {
  <ng-content></ng-content>
  }
</div>
